import React from 'react';
import PropTypes from 'prop-types';

import DropDownComponent from 'components/List/Dropdown';
import BusinessCategoryList from './BusinessCategoryRow';

const CategoryDropDown = ({ categories }) => (
  <DropDownComponent title={"..."}>
    <BusinessCategoryList
      categories={categories}
      dropDown
    />
  </DropDownComponent>
);

export default CategoryDropDown;

CategoryDropDown.propTypes = {
  categories: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/businesses/category/CategoryDropDown.js